/**
 * Created by frank.law on 11/14/17.
 */
import {
    REQUEST_BEGIN,
    REQUEST_END,
    INPUT_ERROR,
    BACK_TO_LOGIN,
    UPDATE_OAUTH_PROPS,
    UPDATE_RESET_TOKEN,
    SHOW_USER_MESSAGE,
    REDIRECT_FOR_CODE,
    REDIRECT_FOR_TOKEN,
    REDIRECT_TO_URL,
    SUBMIT_SAML_REQUEST,
    CHALLENGE_SUCCESS,
    UPDATE_APP_LOGO,
    SUBMIT_REGION_REDIRECT_REQUEST,
    SUBMIT_STANDARD_LOGIN_REGION_REDIRECT
} from '../actions/actions';
import RequestQueueUtil from '../utils/RequestQueueUtil';
import PropTypes from 'prop-types';
import queryString from 'query-string-for-all';


export default function login(state = {}, action) {

    let loginResponse;
    switch (action.type) {
        case REQUEST_BEGIN:
            let newRequestQueueAdd = RequestQueueUtil.addQueueKey(state.requestQueue, action.requestKey);
            return Object.assign({}, state, {
                isLoading: true,
                requestQueue: newRequestQueueAdd
            });

        case REQUEST_END:
            let newRequestQueueRemove = RequestQueueUtil.removeQueueKey(state.requestQueue, action.requestKey);
            return Object.assign({}, state, {
                isLoading: false,
                requestQueue: newRequestQueueRemove
            });

        case INPUT_ERROR:
            return Object.assign({}, state, {
                errorText: action.error,
            });

        case CHALLENGE_SUCCESS:
            loginResponse = new LoginResponse(action.response);
            return Object.assign({}, state, loginResponse, {
                errorText: undefined
            });

        case UPDATE_APP_LOGO:
            return Object.assign({}, state, {
                appLogo: action.appLogo,
                appName: action.appName
            });

        case UPDATE_OAUTH_PROPS:
            return Object.assign({}, state, {
                responseType: action.responseType,
                clientId: action.clientId,
                redirectURI: action.redirectURI,
                state: action.clientState,
                redirect: action.redirect,
                codeChallenge: action.codeChallenge,
                codeChallengeMethod: action.codeChallengeMethod,
                prompt: action.prompt
            });

        case UPDATE_RESET_TOKEN:
            return Object.assign({}, state, {
                resetToken: action.resetToken
            });

        case SHOW_USER_MESSAGE:
            return Object.assign({}, state, {
                messageTitle: action.title,
                messageBody: action.message,
                challengeResponse: { nextChallenge: action.challenge },
                iconName: action.iconName
            });

        case BACK_TO_LOGIN:
            return Object.assign({}, state, {
                errorText: undefined,
            });

        case REDIRECT_FOR_CODE:
            window.location.replace(queryString.stringifyUrl(
                {
                    url: action.targetUrl,
                    query: {
                        code: action.code,
                        state: action.state,
                        region: encodeURIComponent(action.regionName),
                        platform: action.platform ? encodeURIComponent(action.platform) : undefined
                    }
                }, {
                    skipEmptyString: true
                }
            ));
            return Object.assign({}, state, {});

        case REDIRECT_FOR_TOKEN:
            window.location.replace(queryString.stringifyUrl(
                {
                    url: action.targetUrl,
                    query: {
                        region: encodeURIComponent(action.regionName),
                        platform: action.platform ? encodeURIComponent(action.platform) : undefined
                    },
                    fragmentIdentifier: queryString.stringify({
                        access_token: action.accessToken,
                        token_type: action.tokenType,
                        state: action.state})
                }, {
                    skipEmptyString: true
                }
            ));
            return Object.assign({}, state, {});

        case REDIRECT_TO_URL:
            window.location.replace(queryString.stringifyUrl(
                {
                    url: action.targetUrl,
                    query: {
                        state: action.state,
                        region: encodeURIComponent(action.regionName),
                        platform: action.platform ? encodeURIComponent(action.platform) : undefined
                    }
                }, {
                    skipEmptyString: true
                }
            ));
            return Object.assign({}, state, {});

        case SUBMIT_SAML_REQUEST:
            if (action.signatureAlgorithm === "") {
                return Object.assign({}, state, {
                    ssoEndpoint: action.ssoEndpoint,
                    authnRequest: action.authnRequest,
                    token: action.token
                });
            }
            else {
                window.location.replace(queryString.stringifyUrl(
                    {
                        url: action.ssoEndpoint,
                        query: {
                            SAMLRequest: encodeURIComponent(action.authnRequest),
                            RelayState: encodeURIComponent(action.token),
                            SigAlg: encodeURIComponent(action.signatureAlgorithm)
                        }
                    }
                ));
                return {};
            }

        case SUBMIT_REGION_REDIRECT_REQUEST:
            return Object.assign({}, state, {
                redirectEndpoint: action.redirectEndpoint,
                username: action.username
            });

        case SUBMIT_STANDARD_LOGIN_REGION_REDIRECT:
            return Object.assign({}, state, {
                standardLoginRedirectUrl: action.redirectUrl,
                standardLoginRedirectEmail: action.redirectEmail,
                standardLoginRedirectCodeChallenge: action.redirectCodeChallenge,
                standardLoginRedirectCodeChallengeMethod: action.redirectCodeChallengeMethod
            });

        default:
            return state;
    }
}

export class LoginResponse {
    constructor(response){
        this.authComplete = response.authComplete;
        this.failedAuth = response.failedAuth;
        this.token = response.token;
        this.challengeResponse = new NextChallenge(response.nextChallenge);
    }
}

LoginResponse.propTypes = {
    authComplete: PropTypes.bool,
    failedAuth: PropTypes.bool,
    token: PropTypes.string,
    nextChallenge: PropTypes.object
};

export class NextChallenge {
    constructor(challengeResponse){
        this.title = challengeResponse.title;
        this.nextChallenge = challengeResponse.nextChallenge;
        this.submitLabel = challengeResponse.submitLabel;
        this.responseType = challengeResponse.responseType;
        this.targetUrl = challengeResponse.targetUrl;
        this.ssoEndpoint = challengeResponse.ssoEndpoint;
        this.signatureAlgorithm = challengeResponse.signatureAlgorithm;
        this.authnRequest = challengeResponse.authnRequest;
        this.relayState = challengeResponse.state;
        this.code = challengeResponse.code;
        this.state = challengeResponse.state;
        this.accessToken = challengeResponse.accessToken;
        this.tokenType = challengeResponse.tokenType;
        this.prompts = challengeResponse.prompts;
        this.redirectEndpoint = challengeResponse.redirectEndpoint;
        this.username = challengeResponse.username;
        this.regionName = challengeResponse.regionName;
        this.platform = challengeResponse.platform;
    }
}

NextChallenge.propTypes = {
    title: PropTypes.string,
    prompts: PropTypes.arrayOf(PropTypes.object),
    nextChallenge: PropTypes.string,
    submitLabel: PropTypes.string,
    responseType: PropTypes.string,
    targetUrl: PropTypes.string,
    ssoEndpoint: PropTypes.string,
    signatureAlgorithm: PropTypes.string,
    authnRequest: PropTypes.string,
    relayState: PropTypes.string,
    code: PropTypes.string,
    state: PropTypes.string,
    accessToken: PropTypes.string,
    tokenType: PropTypes.string,
    redirectEndpoint: PropTypes.string,
    username: PropTypes.string,
    regionName: PropTypes.string,
    platform: PropTypes.string
};

export class Prompt {
    constructor(newPrompt){
        this.label = newPrompt.label;
        this.promptType = newPrompt.promptType;
        this.id = newPrompt.id;
        this.placeholder = newPrompt.placeholder;
        this.value = newPrompt.value;
    }
}

Prompt.propTypes = {
    label: PropTypes.string,
    promptType: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string
};
